module.exports = __webpack_public_path__ + "static/media/Back_1.33d0e59b.jpg";